// TemplateCreator and EnvelopeCreator both prefill a name and email subject from the first
// document added to the wizard. They used to carry their own copy of this, wired only into the
// "use an existing template" path — so uploading a PDF prefilled nothing, and TemplateCreator
// then blocked on "Please enter a template name". Fixing one copy left the other broken, which
// is why this lives in one place now.

// Selection order holds both kinds: { type: 'template' | 'file', id }. Whichever the user added
// first names the wizard, so a mixed selection stays predictable.
function firstDocumentName (selectionOrder, docs, templates) {
  const first = selectionOrder[0]

  if (!first) return null

  if (first.type === 'template') {
    const template = templates.find((t) => t.id === first.id)

    return (template && (template.document_name || template.name)) || null
  }

  const doc = docs.find((d) => d.id === first.id)

  // Templates are stored without the extension — the server names them
  // File.basename(filename, '.*') — so strip it here or an uploaded document reads "foo.pdf"
  // where a template-backed one reads "foo".
  return doc ? doc.name.replace(/\.[^.]+$/, '') : null
}

export { firstDocumentName }
